import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { pollAndCache } from '../rxjs-operators';

@Injectable({
  providedIn: 'root',
})
export class VideoService {
  public CurrentEvents$: Observable<any>;
  public CdnOptions$: Observable<any>;

  constructor(private http: HttpClient) {
    this.CurrentEvents$ = this.http.get<any>(`${environment.glassApiUrl}/v2/currentevents`).pipe(pollAndCache(30_000));
    this.CdnOptions$ = this.http.get<any>(`${environment.glassApiUrl}/v2/config/cdns`).pipe(pollAndCache(60_000));
  }

  getRunningEvents() {
    return this.CurrentEvents$;
  }

  getCDNOptions() {
    return this.CdnOptions$;
  }

  getEvents() {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/events`);
  }

  getEvent(eventId: number) {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/events/${eventId}`);
  }

  getMediumData(mediaId: string, env: string) {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/medium/${mediaId}/${env}`);
  }

  getStreamStatus(streamIds: string) {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/stream/health/${streamIds}`);
  }

  getEdgeVersions() {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/edge/versions`);
  }

  getHarroDomains() {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/admin/yospaceHarroDomains`);
  }

  saveHarroDomains(domains: string[]) {
    return this.http.put<any>(`${environment.glassApiUrl}/v2/admin/yospaceHarroDomains`, { domains });
  }

  getHarroData() {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/admin/yospaceHarroData`);
  }

  getScteForEvent(eventId: string) {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/events/${eventId}/logs`);
  }

  getQuickVodReport(brand: string, selectedTimeFrame: string) {
    return this.http.get<any>(`${environment.glassApiUrl}/v2/quickVod/${brand}/${selectedTimeFrame}`);
  }
}
